import Vue from "vue";
import common = require("../../../common");
import utilities = require("../../utilities");
import HotEditableTextboxComponent = require("./HotEditableTextboxComponent");
import HotEditableSelectComponent = require("./HotEditableSelectComponent");
import HotEditableDatePickerComponent = require("./HotEditableDatePickerComponent");
import HotEditableCheckboxComponent = require("./HotEditableCheckboxComponent");
import HotEditableButtonComponent = require("./HotEditableButtonComponent");
import HotEditableMessageComponent = require("./HotEditableMessageComponent");
import HotEditableDoubleSelectsComponent = require("./HotEditableDoubleSelectsComponent");
import HotEditableAddressComponent = require("./HotEditableAddressComponent");
import HotEditableMultiSelectComponent = require("./HotEditableMultiSelectComponent");
import HotEditableImageUploadComponent = require("./HotEditableImageUploadComponent");
import HotEditableDocumentUploadComponent = require("./HotEditableDocumentUploadComponent");
import HotEmbeddedFormComponent = require("./HotEmbeddedFormComponent");
import HotEditableHiddenFieldComponent = require("./HotEditableHiddenFieldComponent");
import HotEditableDocumentsUploadComponent = require("./HotEditableDocumentsUploadComponent");

class HotEditableFormLoader {
    /** Attribut permettant d'identifier qu'un element doit etre transforme en tag HE */
    private static readonly _rootAttribute = "hot-editable";
    /** Liste des tags HE supportant l'ajout de HotEditableMessage */
    private static readonly _tagNamesWithMessageSupport = [
        HotEditableTextboxComponent.tagName,
        HotEditableCheckboxComponent.tagName,
        HotEditableDatePickerComponent.tagName,
        HotEditableSelectComponent.tagName,
        HotEditableMultiSelectComponent.tagName
    ];

    // STATIC METHODS
    static prepareComponentsMarkupFromTarget(appendFieldMessages?: boolean, appendConcurrencySumCheck?: boolean, rootId?: string) {
        appendFieldMessages = appendFieldMessages === true;//Default is FALSE
        appendConcurrencySumCheck = appendConcurrencySumCheck !== false;//Default is TRUE

        const rootTarget = rootId ? '#' + rootId : 'body';
        const $root = $(rootTarget);
        const $hotEditable = $root.find('[' + HotEditableFormLoader._rootAttribute + ']');

        for (let i = 0; i < $hotEditable.length; i++) {
            const el = $hotEditable[i];
            const $he = $(el);
            const he = $he.attr(HotEditableFormLoader._rootAttribute);

            if (he === 'message') {
                HotEditableMessageComponent.prepareMarkup(el);
                continue;
            }

            if ($he.is("select")) {
                if (el.hasAttribute('multiple'))
                    HotEditableMultiSelectComponent.prepareMarkup(el as HTMLSelectElement);
                else
                    HotEditableSelectComponent.prepareMarkup(el as HTMLSelectElement);
                continue;
            }

            if ($he.is('button')) {
                HotEditableButtonComponent.prepareMarkup(el);
                continue;
            }

            const t = $he.attr('type');

            if (t === 'date' || he === 'datepicker') {
                HotEditableDatePickerComponent.prepareMarkup(el);
                continue;
            }

            if (t === 'checkbox' || he === 'checkbox') {
                HotEditableCheckboxComponent.prepareMarkup(el);
                continue;
            }

            if (t === 'hidden' || he === 'hiddenfield') {
                HotEditableHiddenFieldComponent.prepareMarkup(el);
                continue;
            }

            //if(!t||t==='text'||t==='password'||t==='textbox')
            HotEditableTextboxComponent.prepareMarkup(el);
        }

        if (appendFieldMessages)
            this.appendFieldMessageComponents($root);

        if (appendConcurrencySumCheck)
            this.appendConcurrencySumCheckField($root, rootId);

        return this;
    }

    static loadComponentsFromParent(parent: common.IHotEditableFormParentVue) {
        const o = {};

        o[HotEmbeddedFormComponent.tagName] = HotEmbeddedFormComponent;
        o[HotEditableSelectComponent.tagName] = HotEditableSelectComponent;
        o[HotEditableMultiSelectComponent.tagName] = HotEditableMultiSelectComponent;
        o[HotEditableCheckboxComponent.tagName] = HotEditableCheckboxComponent;
        o[HotEditableDatePickerComponent.tagName] = HotEditableDatePickerComponent;
        o[HotEditableTextboxComponent.tagName] = HotEditableTextboxComponent;
        o[HotEditableImageUploadComponent.tagName] = HotEditableImageUploadComponent;
        o[HotEditableDocumentUploadComponent.tagName] = HotEditableDocumentUploadComponent;
        o[HotEditableDocumentsUploadComponent.tagName] = HotEditableDocumentsUploadComponent;
        o[HotEditableButtonComponent.tagName] = HotEditableButtonComponent;
        o[HotEditableMessageComponent.tagName] = HotEditableMessageComponent;
        o[HotEditableDoubleSelectsComponent.tagName] = HotEditableDoubleSelectsComponent;
        o[HotEditableAddressComponent.tagName] = HotEditableAddressComponent;
        o[HotEditableHiddenFieldComponent.tagName] = HotEditableHiddenFieldComponent;
        //o[HotEditableTinymceComponent.tagName] = HotEditableTinymceComponent;

        (parent as any as Vue).$options.components = o;
    }

    /** Inject le hidden field de la concurrence. Requiere la presence d'un tag "form" incluant l'attribut "vue-id" dont la valeur est identique a cette du "id" du module vue racine. */
    private static appendConcurrencySumCheckField($root: JQuery, rootId?: string) {
        if (!$root)
            throw "L'argument '$root' est NULL.";
        var form: any;
        if ($root.is("form")) {
            form = $root;
        } else {
            var target = rootId ? "form[vue-id='" + rootId + "']" : "form";
            form = $root.find(target);

            // Decommenter pour trouver le formulaire dont le "vue-id" est manquant.
            // if (!form.length)
            //     throw "Le formulaire correspondant a la cible '" + target + "' n'existe pas.";
        }

        if (!form.length)
            return;

        const field = document.createElement(HotEditableHiddenFieldComponent.tagName);
        const name = "ConcurrencySumCheck";
        field.setAttribute("init-name", name);
        field.setAttribute("init-id", name + "_" + utilities.createGuid("N"));
        form[0].appendChild(field);
    }

    // private static appendDefaultMessageComponent($root: JQuery) {
    //     const form = $root.find('form');
    //     if (!form.length)
    //         return;

    //     const message = document.createElement(HotEditableMessageComponent.tagName);
    //     const name = "DefaultFormMessage";
    //     message.setAttribute("init-name", name);
    //     message.setAttribute("init-id", name + "_" + utilities.createGuid("N"));
    //     form[0].prepend(message);
    // }

    private static appendFieldMessageComponents($root: JQuery) {
        for (let i = 0; i < this._tagNamesWithMessageSupport.length; i++) {
            const elements = $root.find(this._tagNamesWithMessageSupport[i]);
            if (elements)
                for (let j = 0; j < elements.length; j++)
                    this.appendFieldMessageComponent(elements[j]);
        }
    }

    private static appendFieldMessageComponent(el: Element) {
        if (!el)
            throw "L'argument 'el' est requis.";
        const message = document.createElement(HotEditableMessageComponent.tagName);
        const refId = el.getAttribute('init-id');
        if (!refId)
            throw "L'attribut 'init-id' n'existe pas.";
        const refFieldName = el.getAttribute('init-name');
        if (!refFieldName)
            throw "L'attribut 'init-name' du champs en refere n'existe pas.";
        message.setAttribute('init-id', 'HEMessage_' + refId);
        message.setAttribute('init-field-name', refFieldName);
        message.setAttribute('init-mode', common.HotEditableFormMessageModes.field)
        message.setAttribute('v-bind:init-auto-close-on-form-action', 'true');
        if (el.parentNode)
            el.parentNode.appendChild(message);
        else
            utilities.printError("L'élement n'a pas de parent.");
    }
}
export = HotEditableFormLoader;